import { Text, Box } from '@shopify/polaris';

/**
 * T028: ScanMessages component.
 * Renders the current rotating message from useScanMessages.
 */
interface ScanMessagesProps {
  message: string;
  messageIndex: number;
  totalMessages: number;
}

export function ScanMessages({ message }: Readonly<ScanMessagesProps>) {
  return (
    <Box paddingBlockStart="200" paddingBlockEnd="200">
      <Text as="p" variant="bodyMd" tone="subdued" alignment="center">
        {message}
      </Text>
    </Box>
  );
}
